import React from 'react';
import { Checkbox } from '../../../components';
import './ReportTable.scss';

const classnames = require('classnames');
const Download = require('./download.svg');

export interface IDAble {
  id: string;
}

interface ReportTableRowProps<T extends IDAble> {
  item: T;
  checked: boolean;
  columnValuesFromItem(item: T): string[];
  classNameFromIndex?(index: number): string | undefined;
  onPressCheckbox(item: T);
  fetchReport(items: string[]);
  isLoading: boolean;
}

export class ReportTableRow<T extends IDAble> extends React.Component<ReportTableRowProps<T>> {
  public onPressCheckbox = () => {
    this.props.onPressCheckbox(this.props.item);
  };

  public fetchReport = () => {
    this.props.fetchReport([this.props.item.id]);
  };

  render() {
    const { checked, item, columnValuesFromItem, classNameFromIndex } = this.props;

    return (
      <tr className={classnames({ 'report-row-checked': checked })}>
        <td className='report-table-checkbox-col'>
          <Checkbox onClick={this.onPressCheckbox} isChecked={checked} />
        </td>
        {columnValuesFromItem(item).map((value, index) => (
          <td className={classNameFromIndex && classNameFromIndex(index)} key={index}>
            {value}
          </td>
        ))}
        <td>
          {this.props.isLoading ? 'Generating...' : <img onClick={this.fetchReport} src={Download} width='35px' />}
        </td>
      </tr>
    );
  }
}
